import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

class UserService {
  constructor() {
    this.api = axios.create({
      baseURL: `${API_URL}/users`,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Interceptor para agregar token de autenticación
    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('adminToken');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Interceptor para manejar errores
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          // Token expirado o inválido
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminData');
          window.location.href = '/admin';
        }
        return Promise.reject(error);
      }
    );
  }

  // Obtener todos los usuarios
  async getUsers() {
    try {
      const response = await this.api.get('/');
      return response.data;
    } catch (error) {
      const errorMessage = this.getErrorMessage(error, 'Error al obtener usuarios');
      throw new Error(errorMessage);
    }
  }

  // Obtener usuario por ID
  async getUserById(id) {
    try {
      const response = await this.api.get(`/${id}`);
      return response.data;
    } catch (error) {
      const errorMessage = this.getErrorMessage(error, 'Error al obtener usuario');
      throw new Error(errorMessage);
    }
  }

  // Buscar usuario por username
  async getUserByUsername(username) {
    try {
      const response = await this.api.get(`/username/${username}`);
      return response.data;
    } catch (error) {
      const errorMessage = this.getErrorMessage(error, 'Error al buscar usuario');
      throw new Error(errorMessage);
    }
  }

  // Crear nuevo usuario
  async createUser(userData) {
    try {
      const response = await this.api.post('/', userData);
      return response.data;
    } catch (error) {
      const errorMessage = this.getErrorMessage(error, 'Error al crear usuario');
      throw new Error(errorMessage);
    }
  }

  // Actualizar usuario
  async updateUser(id, userData) {
    try {
      const response = await this.api.patch(`/${id}`, userData);
      return response.data;
    } catch (error) {
      const errorMessage = this.getErrorMessage(error, 'Error al actualizar usuario');
      throw new Error(errorMessage);
    }
  }

  // Eliminar usuario
  async deleteUser(id) {
    try {
      await this.api.delete(`/${id}`);
      return true;
    } catch (error) {
      const errorMessage = this.getErrorMessage(error, 'Error al eliminar usuario');
      throw new Error(errorMessage);
    }
  }

  // Método para obtener mensajes de error amigables
  getErrorMessage(error, defaultMessage) {
    if (error.response?.data?.message) {
      return error.response.data.message;
    }
    
    // Manejar errores específicos de red
    if (error.code === 'NETWORK_ERROR') {
      return 'Error de conexión. Verifica tu conexión a internet.';
    }
    
    if (error.response?.status === 409) {
      return 'Conflicto: Los datos proporcionados ya existen en el sistema.';
    }
    
    if (error.response?.status === 400) {
      return 'Datos inválidos. Por favor, verifica la información ingresada.';
    }
    
    if (error.response?.status === 404) {
      return 'Recurso no encontrado.';
    }
    
    if (error.response?.status === 500) {
      return 'Error interno del servidor. Por favor, intenta nuevamente.';
    }
    
    return defaultMessage;
  }
}

const userService = new UserService();
export default userService; 